import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { NUTRIENT_RECOMMENDATION_GRADIENT_COLORS } from "../../../theme/theme";

const ARROW_SIZE = 15;
const CHAIN_WIDTH = "90%";

const LEGEND_START_COLOR = NUTRIENT_RECOMMENDATION_GRADIENT_COLORS.BAD;
const LEGEND_END_COLOR = NUTRIENT_RECOMMENDATION_GRADIENT_COLORS.GOOD;

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    flexWrap: "nowrap",
  },
  chainItem: {
    height: 30,
    width: CHAIN_WIDTH,
    display: "flex",
    alignItems: "center",
  },
  chainItemTypo: {
    color: theme.palette.error.contrastText,
    fontSize: 20,
    marginBottom: 14,
  },
  firstChainItemArrow: {
    borderStyle: "solid",
    borderWidth: `${ARROW_SIZE}px ${ARROW_SIZE}px ${ARROW_SIZE}px 0px`,
    borderColor: `transparent ${LEGEND_START_COLOR} transparent transparent`,
  },
  fifthChainItemArrow: {
    borderStyle: "solid",
    borderWidth: `${ARROW_SIZE}px ${ARROW_SIZE}px ${ARROW_SIZE}px 0px`,
    borderColor: `transparent ${LEGEND_END_COLOR} transparent transparent`,
    transform: "rotate(180deg)",
  },
  chainSpacer: {
    width: CHAIN_WIDTH,
  },
  chainSpacerFirst: {
    marginLeft: ARROW_SIZE,
  },
  chainSpacerFifth: {
    marginRight: ARROW_SIZE,
  },
  middleChainItem: {
    backgroundImage: `linear-gradient(to right, ${LEGEND_START_COLOR}, ${theme.palette.grey[200]}, ${LEGEND_END_COLOR})`,
  },
}));

interface INutrientLegendProps {}

export const NutrientLegend: FunctionComponent<INutrientLegendProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid container justify="center" className={classes.container}>
        <Grid item className={`${classes.firstChainItemArrow}`} />
        <Grid container item justify="space-between" className={`${classes.chainItem} ${classes.middleChainItem}`}>
          <Grid item className={classes.chainItemTypo}>
            <Typography>-</Typography>
          </Grid>
          <Grid item className={classes.chainItemTypo}>
            <Typography>+</Typography>
          </Grid>
        </Grid>
        <Grid item className={`${classes.fifthChainItemArrow}`} />
      </Grid>
      <Grid container justify="center" className={classes.container}>
        <Grid item className={`${classes.chainSpacer} ${classes.chainSpacerFirst}`}>
          <Typography align="center">{t("nutrient.decrease")}</Typography>
        </Grid>
        <Grid item className={classes.chainSpacer} />
        <Grid item className={classes.chainSpacer}>
          <Typography align="center">{t("nutrient.neutral")}</Typography>
        </Grid>
        <Grid item className={classes.chainSpacer} />
        <Grid item className={`${classes.chainSpacer} ${classes.chainSpacerFifth}`}>
          <Typography align="center">{t("nutrient.increase")}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
